module.exports = __webpack_public_path__ + "img/fasts.aeb174bc.svg";